import React, { useEffect, useState } from "react";
import { BackToTop, Button, ButtonPrimary, Content, FloatingButtons, Footer, InicioContainer, MapContainer, MapFrame, NavItem, NavMenu, Overlay, ProductCard, ProductGrid, RelatedCard, Section, Subtitle, Title, ToggleButton, WhatsAppButon } from "./styles";
import { useLocation, useNavigate } from "react-router-dom";
import { FaWhatsapp } from "react-icons/fa";

const Inicio = () => {
    const [collapsed, setCollapsed] = useState(false);
    const [showButton, setShowButton] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const elements = document.querySelectorAll(".animate");

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if(entry.isIntersecting) {
                        entry.target.classList.add("visible");
                    }
                });
            },
            { threshold: 0.2}
        );

        elements.forEach((el) => observer.observe(el));

        return () => observer.disconnect();
    }, []);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 300) {
                setShowButton(true);
            } else {
                setShowButton(false);
            }
        };

        window.addEventListener("scroll", handleScroll);

        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    useEffect(() => {
        if(collapsed) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }

        return () => {
            document.body.style.overflow = "auto";
        };
    }, [collapsed])

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };

    const mensajeRenta = () => {
        const numero = "5213311407070"
        const mensaje = `Hola, me interesa rentar un traje, ¿podría ver su cátalogo?`;
        const url = `https://wa.me/${numero}?text=${mensaje}`

        window.open(url, "_blank")

    }

    const mensajeVenta = () => {
        const numero = "5213311407070"
        const mensaje = `Hola, me interesa comprar un traje, ¿qué costo tiene y cuánto tiempo de anticipación necesito?`;
        const url = `http://wa.me/${numero}?text=${mensaje}`;

        window.open(url, "_blank")
    }

    const mensajeGeneral = () => {
        const numero = "5213311407070"
        const mensaje = `Hola, me gustaría recibir información sobre sus trajes.`;
        const url = `https://wa.me/${numero}?text=${mensaje}`;
        window.open(url, "_blank");
    };

    return (
        <>
            <InicioContainer>
                <ToggleButton collapsed={collapsed} onClick={() => setCollapsed(!collapsed)}>
                    {collapsed ? "✕" : "☰"}
                </ToggleButton>

                <NavMenu collapsed={collapsed}>
                    <NavItem active = {location.pathname === "/"} onClick={() => navigate("/")}>Inicio</NavItem>
                    <NavItem active = {location.pathname === "/trajes"} onClick={() => navigate("/trajes")}>Trajes</NavItem>
                    <NavItem active = {location.pathname === "/smokings"} onClick={() => navigate("/smokings")}>Smokings</NavItem>
                    <NavItem active = {location.pathname === "/togas"} onClick={() => navigate("/togas")}>Togas</NavItem>
                    <NavItem>
                        <a
                            href="/catalogo-trajes" 
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Catálogo de Trajes
                        </a>
                    </NavItem>
                    <NavItem>
                        <a 
                            href="/catalogo-togas" 
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Catálogo de Togas
                        </a>
                    </NavItem>
                    <NavItem><a href="https://wa.me/5213311407070" target="_blank" rel="noopener noreferrer">Contacto</a></NavItem>
                </NavMenu>
                <Overlay collapsed={collapsed} />

                <Content>
                    <Title>Antes de hablar, ya dijiste todo</Title>
                    <Subtitle>
                        Trajes que hablan por ti en cada ocasión
                    </Subtitle>

                    <Button>
                        <ButtonPrimary onClick={() => mensajeRenta()}>Rentar</ButtonPrimary>
                        <ButtonPrimary onClick={() => mensajeVenta()}>Comprar</ButtonPrimary>
                    </Button>
                </Content>
            </InicioContainer>

            <Section>
                <h2>Destacados</h2>
                <ProductGrid>
                    <ProductCard 
                        onClick={() => navigate("/trajes")}
                        className="animate"
                        delay="0s" 
                    >
                        <img src="/img/mx2.jpg" alt="Traje México"/>
                        <span className="hover-text">Ver trajes</span>
                        <p>Trajes de presencia ejecutiva</p>
                    </ProductCard>

                    <ProductCard 
                        className="animate" delay="0.2s"
                        onClick={() => navigate("/smokings")}
                    >
                        <img src="/img/br2.jpg" alt="Smoking Berlín"/>
                        <span className="hover-text">Ver smokings</span>
                        <p>Smokings con elegancia para eventos formales</p>
                    </ProductCard>

                    <ProductCard 
                        className="animate" delay="0.4s"
                        onClick={() => navigate("/togas")}
                    >
                        <img src="/img/Togas.jpg" alt="Togas"/>
                        <span className="hover-text">Ver togas</span>
                        <p>Togas para graduaciones con porte</p>
                    </ProductCard>
                </ProductGrid>
            </Section>

            <Section>
                <h2>Sucursales</h2>
                <ProductGrid>
                    
                    <RelatedCard onClick={() => window.open("https://maps.app.goo.gl/z6hydkdzhPTiYZ346", "_blank")}>
                        <p>Belisario</p>
                        <MapContainer>
                            <MapFrame
                                title="Sucursal Belisario"
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4523.934659384963!2d-103.32129683799256!3d20.6980335163226!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8428b1ca169c880f%3A0x1af7fd554e7973aa!2sRenta%20de%20trajes%20MR!5e0!3m2!1ses!2smx!4v1775093075111!5m2!1ses!2smx" width="600" height="450" style={{border: 0}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"
                                referrerPolicy="no-referrer-when-downgrade"

                            />
                        </MapContainer>
                    </RelatedCard>

                    <RelatedCard onClick={() => window.open("https://maps.app.goo.gl/8T17YtzRPVhtvbtV8", "_blank")}>
                        <p>San Onofre</p>
                        <MapContainer>
                            <MapFrame 
                                title="Sucursal San Onofre"
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d960.7637641515462!2d-103.2945880800007!3d20.69685300230278!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8428b18dd6ace8b1%3A0x17cf1adc53f85c4a!2sRenta%20de%20Trajes%20MR!5e0!3m2!1ses!2smx!4v1775093327350!5m2!1ses!2smx" width="600" height="450" style={{border:0}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"
                                referrerPolicy="no-referrer-when-downgrade"
                            />
                        </MapContainer>
                    </RelatedCard>

                    <RelatedCard onClick={() => window.open("https://maps.app.goo.gl/y7jxQhfE3Wk4KmFV6", "_blank")}>
                        <p>Santa Cecilia</p>
                        <MapContainer>
                            <MapFrame 
                                title="Sucursal Santa Cecilia"
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14928.574901205206!2d-103.30098335!3d20.7043875!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8428b1e9949bac2d%3A0x53345ed9e13fce48!2sRenta%20de%20trajes%20MR!5e0!3m2!1ses!2smx!4v1775354878391!5m2!1ses!2smx" width="600" height="450" style={{border:0}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"
                                referrerPolicy="no-referrer-when-downgrade"
                            />
                        </MapContainer>
                    </RelatedCard>

                    <RelatedCard onClick={() => window.open("https://maps.app.goo.gl/xtzLU4zdJ82jSho28", "_blank")}>
                        <p>Av. De la Cruz</p>
                        <MapContainer>
                            <MapFrame 
                                title="Sucursal Av. De la Cruz"
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d11196.945681805095!2d-103.31486480098448!3d20.70134680080218!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8428b1001cdcddd5%3A0x1db61a431a2ee3d3!2sRenta%20de%20trajes%20MR!5e0!3m2!1ses!2smx!4v1775354968815!5m2!1ses!2smx" width="600" height="450" style={{border:0}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"
                                referrerPolicy="no-referrer-when-downgrade"
                            />
                        </MapContainer>
                    </RelatedCard>

                    <RelatedCard onClick={() => window.open("https://maps.app.goo.gl/5jDHnNBtFRuAQ1qEA", "_blank")}>
                        <p>Circunvalación Oblatos</p>
                        <MapContainer>
                            <MapFrame 
                                title="Sucursal Circunvalación"
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d13316.58241102399!2d-103.31730254616095!3d20.688875568383214!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8428af7bb35502c9%3A0x7e04168024dd6b20!2sRenta%20de%20trajes%20MR!5e0!3m2!1ses!2smx!4v1775355090010!5m2!1ses!2smx" width="600" height="450" style={{border:0}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"
                                referrerPolicy="no-referrer-when-downgrade"
                            />
                        </MapContainer>
                    </RelatedCard>

                    <RelatedCard onClick={() => window.open("https://maps.app.goo.gl/nYnUPoeNYKtdAh6H6", "_blank")}>
                        <p>San Juan Bosco</p>
                        <MapContainer>
                            <MapFrame 
                                title="San Juan Bosco"
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1177.121729626486!2d-103.31373698655338!3d20.67714078280789!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8428b1c040f69089%3A0xb74f95d7a2a2efb7!2sRenta%20de%20trajes%20MR!5e0!3m2!1ses!2smx!4v1775355208178!5m2!1ses!2smx" width="600" height="450" style={{border:0}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"
                                referrerPolicy="no-referrer-when-downgrade"
                            />
                        </MapContainer>
                    </RelatedCard>
                </ProductGrid>
            </Section>

            <Footer>
                <p>Eleganza Sartoriale</p>
                <p>Guadalajara, Jalisco</p>
                <div>
                    <a href="https://www.instagram.com/renta_de_trajes_mr?utm_source=qr&igsh=MW9pb2VwMnRmeW8zaw==">Intagram</a>
                    <a href="https://www.facebook.com/share/14WVJRCc3W4/">Facebook</a>
                    <a href="https://www.tiktok.com/@rentadetrajesmr?_r=1&_t=ZS-95BqJJ1lF7X">Tik Tok</a>
                </div>
                <div>
                    <p>© 2026 Renta de Trajes MR. Todos los derechos reservados.</p>
                </div>
            </Footer>
            {showButton && (
                <FloatingButtons>
                    <WhatsAppButon onClick={mensajeGeneral}>
                        <FaWhatsapp />
                    </WhatsAppButon>

                    <BackToTop onClick={scrollToTop}>
                        ▲
                    </BackToTop>
                </FloatingButtons>
            )}
        </>
    )
};

export default Inicio;